var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.29172C2 5.60259 2.56899 5.04395 3.27088 5.04395H11.2593C11.9611 5.04395 12.5301 5.60259 12.5301 6.29172C12.5301 6.98085 11.9611 7.53949 11.2593 7.53949H3.27088C2.56899 7.53949 2 6.98085 2 6.29172Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.782C2 11.0928 2.56899 10.5342 3.27088 10.5342H9.4437C10.1456 10.5342 10.7146 11.0928 10.7146 11.782C10.7146 12.4711 10.1456 13.0297 9.4437 13.0297H3.27088C2.56899 13.0297 2 12.4711 2 11.782Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4321 16.9512V6.61249C17.4321 6.02181 17.9198 5.54297 18.5215 5.54297C19.1231 5.54297 19.6108 6.02181 19.6108 6.61249V16.9512C19.6108 17.5419 19.1231 18.0207 18.5215 18.0207C17.9198 18.0207 17.4321 17.5419 17.4321 16.9512Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 17.2721C2 16.583 2.56899 16.0243 3.27088 16.0243H7.99129C8.69317 16.0243 9.26216 16.583 9.26216 17.2721C9.26216 17.9612 8.69317 18.5199 7.99129 18.5199H3.27088C2.56899 18.5199 2 17.9612 2 17.2721Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.008 4.50412L16.119 6.35882C15.8353 6.63727 15.8353 7.08873 16.119 7.36718C16.4025 7.64562 16.8624 7.64562 17.1459 7.36718L18.5215 6.01665L19.897 7.36718C20.1806 7.64562 20.6405 7.64562 20.9241 7.36718C21.2076 7.08873 21.2076 6.63727 20.9241 6.35882L19.035 4.50412C18.7514 4.22568 18.2916 4.22568 18.008 4.50412Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0347 18.9884L21.0156 17.0435C21.2992 16.765 21.2992 16.3136 21.0156 16.0351C20.7319 15.7567 20.2722 15.7567 19.9885 16.0351L18.5211 17.4759L17.0537 16.0351C16.7701 15.7567 16.3103 15.7567 16.0267 16.0351C15.7431 16.3136 15.7431 16.765 16.0267 17.0435L18.0077 18.9884C18.2912 19.2669 18.7511 19.2669 19.0347 18.9884Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSort);
export default __webpack_public_path__ + "static/media/ic_sort.099c9c4dc7252191802710551c28d7e1.svg";
export { ForwardRef as ReactComponent };